import React from 'react';
import { useTranslation } from 'react-i18next';
import { BarChart3, PieChart } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const PayrollReportsAnalyticsCards = ({ departmentStats, salaryDistribution, entries, formatCurrency }) => {
  const { t } = useTranslation();
  return (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <BarChart3 className="h-5 w-5" />
          {t('payrollRep.byDept')}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {departmentStats.map((dept) => (
            <div key={dept.name} className="space-y-2">
              <div className="flex items-center justify-between text-sm">
                <span className="font-medium">{dept.name}</span>
                <span className="text-muted-foreground">{t('payrollRep.empCount', { count: dept.employees })}</span>
              </div>
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <p className="text-muted-foreground">{t('payrollRep.totalBrut')}</p>
                  <p className="font-medium">{formatCurrency(dept.totalGross)}</p>
                </div>
                <div>
                  <p className="text-muted-foreground">{t('payrollRep.avgSal')}</p>
                  <p className="font-medium">{formatCurrency(dept.avgSalary)}</p>
                </div>
              </div>
              {departmentStats.length > 1 && (
                <div className="w-full bg-muted rounded-full h-2">
                  <div
                    className="bg-primary h-2 rounded-full"
                    style={{ width: `${(dept.totalGross / Math.max(...departmentStats.map((d) => d.totalGross))) * 100}%` }}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>

    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <PieChart className="h-5 w-5" />
          {t('payrollRep.salaryDist')}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {salaryDistribution.map((range) => (
            <div key={range.label} className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-3 h-3 bg-primary rounded-full"></div>
                <span className="text-sm font-medium">{range.label}</span>
              </div>
              <div className="text-right">
                <p className="text-sm font-semibold">{range.count}</p>
                <p className="text-xs text-muted-foreground">
                  {((range.count / entries.length) * 100).toFixed(1)}%
                </p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  </div>
  );
};

export default PayrollReportsAnalyticsCards;
